export default {
    public: {
        add: '追加',
        confirm: '確認',
        cancel: 'キャンセル',
        continue: '続行',
        success: '成功',
        delSuccess: '削除成功',
        copySuccess: 'コピー成功',
        downloadFileReady: 'ダウンロードファイルを準備中です',
        downloadFileReadyText: '準備はバックグラウンドで行われ、他のことを行うか、後でファイルをダウンロードするかを選択できます',
        downloadCenter: 'ダウンロードセンター',
        view: 'ビュー',
        fileReadyComplete: 'ダウンロードファイルが準備完了しました',
        today: '今日',
        recentThreeDays: '最近3日',
        recentOneWeek: '最近1週間',
        recentOneMonth: '最近1ヶ月',
        recentThreeMonths: '最近3ヶ月',
        pleaseEnterKeywords: 'キーワードを入力してください',
        all: 'すべて',
        more:'もっと',
        edit:'編集',
        delete: '削除',
        doNotSubmitAgain: '繰り返し投稿しないでください！',
        store: '店',
        customPleaseEnterComplete: 'カスタムチャネルは、完全な情報を入力する必要があります！！！',
        pleaseSelectData: 'データを選択してください',
        platform: 'プラットフォーム',
        name: '名前',
        price: '価格',
        craft: 'クラフト',
        startTime: '開始時間',
        endTime: '終了時間',
        createStartTime: '作成開始時間',
        createEndTime: '作成終了時間',
        operation: '動く',
        to: '宛先',
        size: 'サイズ',
        status: 'ステータス',
        save: 'セーブ',
        color: '色',
        noData: 'データなし',
        remark: 'メモ',
        systemOperationDocument: 'システム操作ドキュメント',
        reset: 'リセット',
        operationTime: '操作時間',
        order: '注文',
        no:'いいえ',
        yes:'はい',
        themeName: 'テーマ名',
        readThemeName: '製品の対応する言語の件名を読み取り、製品にストアエイリアスがある場合は、ストアエイリアスが読み取られます.',
        blankProductName: '空白製品名',
        readBlankProductName: '空欄の商品名を店舗に対応する言語で読み上げます。',

        description: 'ブランク製品説明',
        readDescription: '現在の商品テンプレートに入力されている商品説明をお読みください。',
        tags: '商品タグ',
        readTags: "変数 '{'tags'}' を使用して、すべての商品タグを読み取ります。\n" +
            "最初のいくつかの商品タグを接尾辞を追加して読み取り、変数 '{'tag + number + suffix '}' を使用します。例：'{'tag5 t shirt'}'；\n" +
            "ランダムな数の商品タグを接尾辞を追加して読み取り、変数 '{'rtag+number + suffix '}' を使用します。例：'{'rtag5 case'}'",
        sizeName: 'サイズ名',
        readSizeName: '現在の商品テンプレートに設定されているカスタムサイズ名を読み取ります。設定されていない場合は、デフォルトのサイズ名が読み取られます。',
        brandName: 'ブランド',
        readBrandName: '現在の商品テンプレートに入力されているブランド名を読み取ります。',
        pending: '待機中',
        designing: 'デザイン中',
        designComplete: 'デザイン完了',
        inProduction: '製造中',
        qualityInspection: '品質検査',
        delivery: '配送中',
        delivered: '配送完了',
        cancelled: 'キャンセル',
        processing: '処理中',
        processingText: 'システムが処理中です、しばらくお待ちください...',
        maxNumData: '一度に最大{maxNum}データを操作できます',
        uploadImage: '画像をアップロード',
    },
    home: {
        onlineDesign: 'オンラインデザイン',
        submitOnline: 'オンライン提出',
        regionLanguage: '地域言語',
        home: 'ホーム',
        allSelect: '全て選択',
        workbench: 'ワークベンチ',
        searchForProducts: '商品を検索',
        goLogin: 'ログインに進む',
        customOrder: 'カスタマイズ註文です',
        generateOrder: '注文書を作成します',
        deliveryOrder: '配送註文です',
        productCustomizable: '製品をカスタマイズ可能',
        cumulativeFreeElements: '累積無料要素',
        startSelecting: '選択を開始',
        efficientSelecting: '効率的な選択',
        efficientSelectingText: 'プラットフォームは豊富なカスタマイズ製品を提供し、ディストリビューターが選択できます',
        designShelf: 'デザインシェルフ',
        designShelfText: '優質な素材を使用して、高品質な商品を効率的に設計します',
        efficientProduction: '効率的な製造',
        efficientProductionText: '注文を同期し、出荷後に工場に商品を発注します',
        oneClickDelivery: '1クリック配送',
        oneClickDeliveryText: 'ユーザーは、ホームページから注文を提出し、出荷後に商品を受け取ることができます',
        displayCustomerService: '顧客',
        joinUS: {
            joinTitle: '私たちに参加して、一緒にプレイして稼ぎましょう',
            joinText1: 'お金を稼ぐ方法は1つしかありません',
            joinText2: '距離',
            ERPDeployIndependently: 'ERPは独立して展開されます',
            ERPDeployIndependentlyText: '他のシステムに依存せずに ERP を独立して導入',
            exclusiveCooperation: '独占コラボレーション',
            exclusiveCooperationText: 'カスタマイズされた製品の製造を教えるための完全なシステムを提供します',
            trainingCooperation: '研修協力',
            trainingCooperationText: '専門的な能力を駆使して、サービスプロバイダーに、安全で信頼性が高く、想像を絶する製品を提供します',
        },
        boutiqueRelease:{
            boutiqueReleaseTitle: 'トレンディなブティックのリリースは、市場でのホットセールに続くものです',
            boutiqueReleaseText: '柔軟なサプライチェーンの最適ソリューションを追求し、OEMをサポート',
            name:'製品名',
            price:'製品価格'
        },
        categoryRich: {
            categoryRichTitle: '豊富なカテゴリ',
            categoryRichText: '当社の製品は、さまざまな顧客のニーズを満たすために豊富なカテゴリがあります',
            viewMore: '続きを読む',
            productMaterial:'製品素材',
            productWeight:'製品重量',
            productSize:'製品サイズ',
            goToDesign:'デザインに進む'
        },
        deployIndependently: {
            deployIndependentlyTitle: 'システムは独立して展開され、ワンストップで柔軟なカスタマイズが可能です',
            deployIndependentlyText: 'カスタマイズされた共有とWin-Winのエコロジー',
            contentText1:'自分のロジスティクスアカウントにアクセスする',
            contentText2:'独立したブランドデザイン/リスト/注文システム',
            contentText3:'個性的にカスタマイズされた製造システム',
            contentText4:'自社のファクトリー製品を接続し、内部の製造ラインを構築',
            contentText5:'独立したドメイン名/独立したテンプレート/独立した製品出力',
            contentText6:'1つのシステムで品質検査と注文を行う',
        },
        logisticsCooperation: {
            logisticsCooperationTitle: '世界中の主要な電子商取引プラットフォームで販売されています',
            logisticsCooperationTitle1: '物流協力',
        },
        page_document: {
            contactUs: 'お問い合わせ',
            serviceHotline: '全国統一サービスホットライン',
            MondayToSaturday: '月曜日から土曜日',
            contactCustomerService:'カスタマーサービスに連絡する',
            addCustomerService:'コードをスキャンしてカスタマーサービスを追加する',
        },
    },

    login: {
        login: 'ログイン',
        username: 'ユーザー名',
        password: 'パスワード',
        rememberMe: 'ログイン情報を記憶する',
        register: '新規登録',
        resetPassword: 'パスワードをリセット',
        returnHome: 'ホームに戻る',
        agreeToTerms: '利用規約に同意する',
        termsOfUse: '利用規約',
        privacyPolicy: 'プライバシーポリシー',
        pleaseEnterPhoneNumber: '電話番号を入力してください',
        pleaseEnterVerificationCode: 'バーコードを入力してください',
        getVerificationCode: 'バーコードを取得',
        unregisteredWillCreateAccount: '未登録の場合は、自動的にDIYDOアカウントが作成されます',
        pleaseEnterUsername: 'ユーザー名を入力してください',
        pleaseEnterPassword: 'パスワードを入力してください',
        pleaseDragSliderToRight: 'スライダーを右にドラッグしてください',
        verifySuccess: '認証成功',
        holdToSlideContinue: 'スライドを保持して続行',
        loginSuccess: 'ログイン成功',
        pleaseCompleteSlider: 'スライダー認証完了後にログインしてください',
        registerTips: '登録して、より多くのメリットを得ましょう',
        passwordNotSame: 'パスワードが一致しません',
        pleaseEnterConfirmationPassword: '確認パスワードを入力してください',
        pleaseEnterAgainPassword: 'パスワードを再入力してください',
        pleaseEnterAccount: 'ログインアカウントを入力してください',
        pleaseEnterPhone: '電話番号を入力してください',
        registerSuccess: '登録成功',
        accountLogin: 'アカウントログイン',
        accountRegister: 'アカウント登録',
        pleaseEnterCompanyName: '会社名を入力してください',
    },

    shop_list:{
        shopList: '選品ライブラリ',
        productName: '製品名',
        productSKU: '製品SKU',
        shopPrice: '￥{ price }から',
        shippingArea: '配送エリア',
        domesticShipping: '国内配送',
        internationalShipping: '国際配送',
        addNewProductDemand: '新しい製品要望を追加',
        imageException: '画像が異常です',
        expectDelivery: '配送予定日数',
        expectDeliveryTime: '2-4 日間の配送',
        titleName: 'タイトル名',
        selectTaskTemplate: 'タスクテンプレートを選択',
        shop: '選品',
        selectEffectImage: '効果画像を選択',
        templateImage: 'テンプレート画像',
        productReferenceLink: '製品参考リンク',
        factoryPriceDemand: '工場価格要望',
        fabricMaterialDemand: '素材要望',
        remark: 'メモ',
        allCategory: '全部分類',
    },

    theme_requi:{
        selection: '選定',
        themeRequirement: 'テーマ要望',
        themeName: 'テーマ名',
        creator: '作成者',
        elementProductionMethod: '要素制作方法',
        behalfOthers: '代制作',
        makeYourOwn: '自己制作',
        themeImage: 'テーマ画像',
        completionStatus: '完成状況',
        pendDevelopment: '待開発',
        subThemeCompleted: '子テーマ開発完了',
        elementCompleted: '要素制作完了',
        completed: '完了',
        remark: 'メモ',
        viewRemark: 'テーマの備考を見る',
        viewSubTheme: '子テーマを見る',
        operation: '操作',
        subThemeDownload: '子テーマをダウンロード',
        themeRemark: 'テーマの備考',
        subThemeInfo: '子テーマ情報',
        feeExplanation: '料金解説',
        themeNameExplanation: 'テーマ名解説',
        howMade: '作り方',
        madeTip: '要素を作るデザイナーとして開発保留中(上記料金基準)',
        behalfOthersTip: '代制作は料金が発生します、上記料金基準を参照してください',
        notice: '告知',
        title: 'タイトル',
        subThemeImage: 'サブテーマ画像',
    },

    customs: {
        selectCustoms: '税関選択',
        customCustomsInfo: 'カスタム税関情報',
        selectProductName: '製品名を選択',
        selectProductNumber: '製品番号を選択',
        productId: '製品ID',
        addProductCustomsInfo: '製品税関情報を追加',
        customsTip: 'プラットフォームプリセット製品通関情報、エージェント申告注文。関税の申告または税関による商品の差し押さえによって生じた損失または損害についてユーザーが責任を負う場合、関税の申告または税関による商品の差し押さえによって生じた損失または損害についてはユーザーが責任を負います。',
        declareChineseName: '中国語名を宣言する',
        size: '大きさ',
        declareEnglishName: '英語名を宣言する',
        productMaterialEnglish: '製品素材（英語）',
        declarePriceUSD: '米ドル価格を宣言する',
        declareWeightG: '重量（g）を宣言する',
        customsCode: '税関コード',
        operation: '操作',
        addNewCustomsProduct: '新しい税関製品を追加',
        editCustomsInfo: '税関情報を編集',
        confirmDeleteCustomsInfo: '税関情報を削除、選択した製品はデフォルトに戻ります、続行しますか？',
        productName: '製品名',
        productSku: '製品SKU',
        templateCategory: 'テンプレートカテゴリ',
        addNewCustomsInfo: '新しい税関情報を追加',
        selectAll: '全て選択',
        imageException: '画像が異常です',
        productAddCustomsInfo: '選択した製品の税関情報を追加',
        batchImport: '一括インポート',
        batchEdit: '一括編集',
        country: '国',
    },

    product_list: {
        productManagement: '製品管理',
        myProducts: 'マイ製品',
        pendingGeneratedProducts: '保留中の生成製品',
        productName: '製品名',
        selectionSKU: '選品SKU',
        operator: '操作人',
        platformSKU: 'プラットフォームSKU',
        designSKU: 'デザインSKU',
        productNumber: '製品番号',
        englishTheme: '英語テーマ',
        selectSubAccount: 'サブアカウントを選択',
        selectAll: '全て選択',
        selectProductTemplate: '製品テンプレートを選択',
        exportStatus: 'エクスポート状態',
        exported: 'エクスポート済み',
        notExported: '未エクスポート',
        compositeProduct: '合成製品',
        designer: 'デザイナー',
        unsold: '未販売',
        productBasicInfo: '製品基本情報',
        viewCompositeProduct: '合成製品を表示',
        pleaseSelectSize: '大きさを選択してください',
        shippingCenter: '配送センター',
        tags: 'タグ',
        finishedSKU: '完成品SKU',
        attachedImages: '添付画像',
        generating: '生成中',
        boundPlatformShopSKU: 'バインドプラットフォーム/ショップ/SKU',
        platformShop: 'プラットフォーム/ショップ',
        unbind: 'バインド解除',
        viewAll: '全て表示',
        createTime: '作成日時',
        productDetail: '製品詳細',
        productEdit: '製品編集',
        addToCart: 'カートに追加',
        moreOperation: 'その他操作',
        downloadHighDefinition: '高解像度ダウンロード',
        associateShop: 'ショップを関連付ける',
        exportProduct: '製品エクスポート',
        manualAssociation: '手動関連付け',
        amazonExport: 'Amazon輸出',
        walmartExport: 'Walmart輸出',
        ebayExport: 'Ebay輸出',
        compositeProductInfo: '合成製品情報',
        compositeProductInfoTips: '不同の工場は組み合わせることができません',
        batchExportTips: '一括エクスポートは、同じテンプレートとテンプレートSKUを持つ商品でのみ使用できます',
        cannotAddToCart: '完成品はカートに追加できません',
        noPermission: '選択した要素を操作する権限がありません',
        confirmDeleteProducts: '製品を削除して続行しますか?',
        confirmUnbind: 'バインドを解除して続行しますか?',
        englishTags: '英語ラベル',
        englishTagsTips: '英語ラベルはカンマ区切りで入力してください',
        updateTime: '更新日時',
        productElement: '製品要素',
        previewImageException: '申し訳ありません、プレビュー画像の読み込みに失敗しました',
        noData: 'データなし',
        productImage: '製品画像',
        platformShopSKU: 'プラットフォーム/ショップ/SKU',
        originalImage: '元画像',
        addNewShop: '新しいショップを追加',
        SKURules: 'SKUルール',
        SKURandomCharacter: 'SKUランダム文字',
        exportProductImage: '商品画像のエクスポート',
        pleaseSelectShop: 'ショップを選択してください',
        pleaseInputSKU: 'SKUを入力してください（大文字小文字を区別します）',
        exportTip: "1. 画像やテキストをアップロードする際に、政治的、 pornography、侵害などの不適切な行為は避けてください。違反すると、禁止措置が取られる可能性があります。ご協力をお願いします。",
        exportTip2: "2.入力フィールドがAmazonと一致しない場合は、Amazonストアにアクセスして最新のテンプレートインポートを再度ダウンロードし、テンプレートをダウンロードするときは必ず単一の国を選択してください。",
        exportProducts: '製品の輸出',
        shop: 'ショップ',
        mainImage: 'メイン画像',
        setMainImage: 'メイン画像として設定',
        removeImage: '削除',
        importantInfo: '重要な情報',
        brand: 'ブランド',
        factory: '工場',
        externalProductNumberType: '外部製品番号の種類',
        retailPrice: '販売価格',
        stock: '在庫',
        optionalInfo: '任意の情報',
        exportTemplate: 'エクスポートテンプレート',
        productTemplate: '製品テンプレート',
        remark: '備考',
        productImageTips: '画像をドラッグして順序を調整してください! 各バリアントは以下の順序で個別に画像をエクスポートします',
        sellingForm: '販売形態',
        singleProduct: '単品',
        sizeVariant: 'サイズバリアント',
        colorVariant: '色バリアント',
        productVariant: '製品バリアント',
        productVariantTips: '「数量の結合」設定に従って、複数のカスタム商品を 1 つの親商品にエクスポートします。',
        colorVariantTips: '色の一意性を確保するため、エクスポート時に同じ色をシーケンス番号で固定します.',
        sizeVariantTips: 'エクスポートするサイズを指定する',
        blankProductName: '空白の製品名',
        size: '大きさ',
        attributeCombination: '属性の組み合わせ',
        namePlusSize: '名前にサイズを追加',
        open: '開ける',
        close: '閉じる',
        openTips: 'エクスポート後に開くと、製品名にサイズ情報が自動的に追加されます',
        insertVariable: '変数を挿入',
        name: '名前',
        variable: '変数',
        declaration: '声明',
        preview: 'プレビュー',
        longDescription: '長い説明',
        sizePrice: 'サイズ価格($)',
        priceSyncToSize: '価格をサイズに同期',
        price: '価格($)',
        fillNumber: '塗りつぶし番号',
        fillNumberTips: '複数の塗りつぶし番号を改行で入力してください',
        SKUQuantityTip:"*{ count1} は必須であり、{count2} が入力されています。{count3} 未満の場合、エクスポートされた製品番号は空になり、必要な数を超えると、システムは自動的に無視します。",
        inventory: '在庫',
        shortDescription1: '短い説明 1',
        shortDescription2: '短い説明 2',
        shortDescription3: '短い説明 3',
        saveTemplate: 'テンプレートを保存する',
        previewVariable: '変数をプレビューする',
        pleaseInputVariableValue: '変数の値を入力してください',
        color: '色',
        quantity: '量',
        importantInformation: '重要な情報',
        optionalInformation: 'オプション情報',
        addToCartQuantity: 'カートに入れる数量',
        maxAddToCartQuantityTips: '最大追加カート数量は { max_nums } です。より多く追加したい場合は、カスタマーサービスまでお問い合わせください',
        unitPrice: '単価（￥）',
        viewCart: 'カートを見る',
        fullEntry: '商品のサイズと数量情報を全部入力してください',
        productInfo: '商品情報',
        compositeProductName: '組み合わせ製品名',
        notEnterCompositeProductNameTips: '組み合わせ製品名を入力しない場合は、最初の組み合わせ製品名がデフォルトで使用されます',
        batchEdit: 'バッチ編集',
        batchDelete: 'バッチ削除',
        batchDownload: 'バッチダウンロード',
        productExport: '製品エクスポート',
        walmartPlatformExport: 'Walmartプラットフォームエクスポート',
        amazonPlatformExport: 'Amazonプラットフォームエクスポート',
        combinationProducts: '組み合わせ製品',
        user_name: '所有者',
        temuExport: 'Temuプラットフォームエクスポート',
    },

    wrmTemplate:{
        productLibrary: '製品ライブラリ',
        exportProductTemplate: '製品テンプレートをエクスポート',
        templateName: 'テンプレート名',
        createStartTime: '作成開始時刻',
        createEndTime: '作成終了時刻',
        templateType: 'テンプレートの種類',
        walmart: 'Walmart',
        attributeCombination: '属性の組み合わせ',
        createTime: '作成時刻',
        deleteExportTemplateConfirm: 'エクスポートテンプレートを削除しますか？',
    },

    bank: {
        imageCategory: '画像分類',
        materialLibrary: '素材ライブラリ',
        myGallery: 'マイギャラリー',
        englishName: '英語名',
        chineseName: '中国語名',
        englishTag: '英語タグ',
        ID: 'ID',
        pleaseSelectSubAccount: 'サブアカウントを選択してください',
        createStartTime: '作成開始時刻',
        createEndTime: '作成終了時刻',
        material: '素材',
        noticeDisableWord: '通知無効ワード',
        shareToAllPlatform: 'すべてのプラットフォームに共有',
        specification: '仕様',
        imagePixel: '画像ピクセル',
        imageType: '画像形式',
        themeImage: 'テーマ画像',
        backgroundImage: '背景画像',
        source: 'ソース',
        createTime: '作成時刻',
        operation: '操作',
        uploadElement: '要素をアップロード',
        editCategory: 'カテゴリを編集',
        editTag: 'タグを編集',
        editImageInfo: '画像情報を編集',
        shareImage: '画像を共有',
        noPermission: '選択した要素を操作する権限がありません',
        batchDeleteConfirm: '画像を削除しますか？',
        uploadTips1: '画像をここにドラッグアンドドロップしてアップロードするか、アップロードをクリックしてください',
        uploadTips2: '画像の通常の使用を保証するために、アップロードは 30M 以内の jpg、jpeg、png 形式の画像のみをサポートします。複数の画像を一度にアップロードできます',
        uploadTips3: '画像やテキストのアップロードには、政治、ポルノ、侵害などの違法なコンテンツが含まれていてはなりません。重大な違反はアカウント停止で罰せられます。ご協力のほどよろしくお願いいたします',
        uploadTips4: '画像やテキストのアップロードには、政治、ポルノ、侵害などの違法なコンテンツが含まれていてはなりません。重大な違反はアカウント停止で罰せられます。ご協力のほどよろしくお願いいたします',
        selectedImageMaterial: '選択した画像素材',
        materialCategory: '素材カテゴリ',
        addTag: 'タグを追加',
        englishTheme: '英語テーマ',
        englishThemeTips: '英語テーマは要素のテーマキーワードです',
        oneKeyEnterImageInfo: '一括入力画像情報',
        setCategory: 'カテゴリを設定',
        oneKeySync: '一括同期',
        uploadImageInfo: '画像情報をアップロード',
        img: "画像",
        uploadFailedImageInfo: 'アップロード失敗画像情報',
        reason: '失敗理由',
        imageSizeTips: '画像サイズが 30M を超えています。より小さな画像をアップロードしてください',
        shareAccount: '共有アカウント',
        uploadImage: '画像をアップロードする',
        changeTag: 'タグを変更する',
        deleteImage: '画像を削除する',
        allCategory: '全部分類',
        deleteCategoryConfirm: '削除分類確認',
        imageSize: '画像サイズ',

        uploadProgress:'アップロード進捗',
        uploadStatus:'アップロード中',
        uploadSuccess:'アップロード成功',
        uploadError:'アップロード失敗',
        uploadWaiting:'待機中',
        unknownStatus:'未知の状態',
        cannotReUpload: '再アップロード不可能: ファイル情報が失われています',
        allFilesUploaded: 'すべてのファイルがアップロードされました。続行してください',
        uploadException:'アップロード中に例外が発生しました',
    },

    forbidden_word:{
        prohibitedWords: '禁止ワード',
        localWordLibrary: 'ローカルワードライブラリ',
        cloudWordLibrary: 'クラウドワードライブラリ',
        serialNumber: 'シリアル番号',
        riskLevel: 'リスクレベル',
        applicablePlatform: '適用プラットフォーム',
        remark: '備考',
        schematicDiagram: 'スキャンダル図',
        createPerson: '作成者',
        deleteForbiddenWordConfirm: '禁止ワードを削除しますか？',
        inputForbiddenWord: '禁止ワードを入力してください',
        inputForbiddenWordTips: '入力が完了したら、Enterキーを押してタグを生成してください',
        lowRisk: '低リスク',
        mediumRisk: '中リスク',
        highRisk: '高リスク',
        allPlatform: 'すべてのプラットフォーム',
        specifiedPlatform: '指定プラットフォーム',
        addToCloudWordLibrary: 'クラウドワードライブラリに追加',
        pleaseAddRemark: '備考を入力してください',
        schematicDiagramTips: '禁止ワードライブラリのスキャンダル図をアップロードしてください。1つの画像のみをサポートし、形式はPNG、JPGで、サイズは10Mを超えてはいけません',
        uploadImageTips: '禁止ワードライブラリのスキャンダル図をアップロードしてください',
        pleaseAddRemarkTips: 'Enterキーを押して禁止ワードライブラリを追加した後、備考を入力してください',
        onlySupportJpgPngFormat: 'jpg、png形式の画像のみをサポートします',
        imageSizeTips: '画像サイズは10Mを超えてはいけません',
        emptyTagTips: '禁止ワードライブラリのタグが空です。禁止ワードライブラリが入力され、Enterキーを押してタグが生成されたことを確認してください',
        startTime: '開始時間',
        endTime: '終了時間',
        createStartTime: '作成開始時刻',
        createEndTime: '作成終了時刻',
        to: '宛先',
        operation: '操作',
        category: '分類',
        importantInformation: '重要情報',
        optionalInformation: '任意情報',
        upload: 'アップロード',
        commonData: '共通データ',
        goRelevantPage: '関連ページに移動',
        myGallery: 'マイギャラリー',
        material: '材料',
        forbiddenWordLibrary: '禁止ワードライブラリ',
    },

    single_element: {
        gallery: '単一要素ギャラリー',
        exportGallery: '出单単一要素ギャラリー',
        exportNum: '出单数量',
        material: '素材',
        materialName: '素材名称',
        designSKU: '設計SKU',
        specification: '规格',
        imagePixel: '图片像素',
        imageSize: '图片大小',
        exportProduct: '出单単一要素製品',
        viewOrder: '表示順',
        order: '出单順',
        productKeywords: '製品キーワード',
        productSKU: '製品SKU',
        productCode: '製品コード',
        operator: '操作人',
        platformSKU: 'プラットフォームSKU',
        productImage: '製品画像',
        attachments: '添付ファイル',
        themeNameEnglish: 'テーマ名 (英語)',
        tags: 'タグ',
        orderNumber: '出单番号',
        platformShopOperator: 'プラットフォーム/ショップ/操作人',
        productNum: '製品番号',
        source: '出单元',
        createTime: '作成時間',
    },

    workList: {
        workOrder: '作業指示書',
        workOrderManagement: '作業指示書管理',
        workOrderTitle: '作業指示書タイトル',
        selectWorkOrderStatus: '作業指示書状態を選択',
        pending: '待処理',
        developed: '待開発',
        developing: '開発中',
        completed: '完了',
        canceled: 'キャンセル',
        addWorkOrder: '作業指示書を追加',
        urgent: '緊急',
        open: '開く',
        close: '閉じる',
        status: '状態',
        expectCompleteTime: '予定完了時刻',
        actualCompleteTime: '実際の完了時刻',
        workOrderDescription: '作業指示書の説明',
        cancelWorkOrder: '作業指示書をキャンセル',
        detailedDescription: '詳細な説明',
        cancelWorkOrderConfirm: '作業指示書をキャンセルしてもよろしいですか？',
        commentContent: 'コメント内容',
        commentUser: 'コメントユーザー',
        commentTime: 'コメント時刻',
    },

    allProducts: {
        searchTips: 'プラットフォーム注目、品質保証、注目の製品',
        explore: '探 る',
        imageException: '画像が異常です',
        craft:'手工芸',
        material:'材料',
        sizeNum:'サイズ数量',
        weight:'重量',
        category:'分類',
        expectDeliveryTime:'配送予定日数',
        topicZone:'テーマエリア',
        allCategory:'全部分類',
    },

    deal_record:{
        statistics:'データ',
        transactionNumber:'トランザクション番号',
        platformOrderNumber:'プラットフォームの注文番号',
        factoryOrderNumber:'工場の注文番号',
        transactionType:'トランザクションタイプ',
        selectSubAccount:'サブアカウントを選択',
        transactionStartTime:'トランザクション開始時刻',
        transactionEndTime:'トランザクション終了時刻',
        exportTransactionRecord:'トランザクションレコードをエクスポート',
        accountRecharge:'アカウント再充電',
        systemOrderNumber:'システム注文番号',
        transactionRecord:'トランザクションレコード',
        amount:'金額 (元)',
        arrivalTime:'到着時刻',
        createTime:'作成時刻',
        balance: '残高（元）',
        cumulativeRecharge:'累積再充電（元）',
        cumulativeExpenditure:'累積支出（元）',
        cumulativeCommission:'累積佣金（元）',
        commissionDetails:'佣金詳情',
        orderCommission:'注文佣金（元）',
        logisticsCommission:'物流佣金（元）',
    },

    distribution_data:{
        statistics:'データ',
        distributionData:'分销データ',
        transactionStartTime:'トランザクション開始時刻',
        transactionEndTime:'トランザクション終了時刻',
        totalSalesAmount:'合計売上高（元）',
        totalProfit:'合計利益（元）',
        companyName:'会社名',
        shippingChannel:'配送チャネル',
        distributionFee:'配送料（元）',
        createTime:'作成時刻',
        distributorTotalSalesAmount:'分销商共计销售额（元）',
        distributorTotalProfitRatio:'分销商累计收益占比（%）',
    },

    order_data:{
        statistics:'データ',
        orderData:'注文データ',
        statisticsType:'統計方法（次元）',
        date:'日付',
        shop:'店舗',
        finishedProduct:'完成品',
        selectedProduct:'選品',
        platform:'プラットフォーム',
        subAccount:'サブアカウント',
        orderStatus:'注文状態',
        totalSalesAmount:'合計売上高（$）',
        totalOrderNum:'合計注文数',
        totalOrderItemNum:'合計注文品数',
        averagePricePerItem:'平均品数価格（$）',
        orderNum:'注文数',
        orderItemNum:'注文品数',
        averageSalesPerItem:'平均品数売上高（$）',
    },

    product_data:{
        statistics:'データ',
        productData:'製品データ',
        startTime:'開始時刻',
        endTime:'終了時刻',
        productStatistics:"カスタム製品データ統計（合計{ count }件）",
        rank:'ランク',
        productNum:'カスタム製品数',
        account:'アカウント',
        viewProductDetail:'製品詳細を表示',
    },

    design_record: {
        productLibrary: '製品ライブラリ',
        designRecord: '設計記録',
        customSKU: 'カスタムSKU',
        user: 'ユーザー',
        templateTitle: 'テンプレートタイトル',
        pass: '通過',
        notPass: '未通過',
        generated: '生成済み',
        waitAudit: '審査待ち',
        generating: '生成中',
        from: '元',
        designLibrary: '設計ライブラリ',
        order: '注文',
        serialNumber: 'シリアル番号',
        templateSKU: 'テンプレートSKU',
        status: '状態',
        userDesignImg: 'ユーザー設計画像',
        effectImg: '効果画像データ',
        operation: '操作',
        createTime: '作成時刻',
        designAudit: '設計審査',
        regenerate: '再生成',
        deleteDesign: '設計を削除',
        auditDesignRecord: '設計記録を審査',
    },

    tuku_data:{
        statistics:'データ',
        tukuStatistics:'画像アップロード数統計',
        subAccount:'サブアカウント',
        imgStatistics:'画像アップロード数統計（合計{ count }件）',
        rank:'ランク',
        uploadNum:'アップロード数',
        uploadAccount:'アップロードアカウント',
    },

    com_cash:{
        statistics:'データ',
        withdrawalRecords:'引き出し記録',
        inputOrderNumber:'入力注文番号',
        commissionType:'コミッションタイプ',
        orderCommission:'注文コミッション',
        logisticsCommission:'物流コミッション',
        logisticsReturnFee:'物流返金',
        withdrawalType:'引き出しタイプ',
        alipay:'アリペイ',
        bankCard:'バンクカード',
        wechat:'チャット',
        balance:'残高',
        currentStatus:'現在の状態',
        pendingReview:'審査待ち',
        reviewPassed:'審査通過',
        reviewRejected:'審査不通过',
        paid:'支払い済み',
        transactionStartTime:'トランザクション開始時刻',
        transactionEndTime:'トランザクション終了時刻',
        totalCommissionBalance:'合計コミッション残高：{count} 元',
        orderCommissionBalance:'注文コミッション残高：{count} 元',
        logisticsCommissionBalance:'物流コミッション残高：{count} 元',
        orderNumber:'注文番号',
        withdrawAmount:'引き出し金額（元）',
        withdrawalAccount:'引き出しアカウント',
        remark:'メモ',
        createTime:'作成時刻',
    },

    frozen_list: {
        systemOrderNumber: 'システムオーダー番号',
        statistics: 'データ',
        frozenAmount: '凍結金額',
        platformOrderNumber: 'プラットフォームの注文番号',
        factoryOrderNumber: '工場の注文番号',
        transactionType: 'トランザクションタイプ',
        factoryProductionFee: '工場の製造料金',
        logisticsFee: '注文物流料金',
        transactionStartTime: 'トランザクション開始時刻',
        transactionEndTime: 'トランザクション終了時刻',
        exportFrozenList: 'エクスポート',
        totalFreezeAmount: '凍結総額:{count}元',
        productionFeeFrozen: '制作料凍結額:{count}元',
        logisticsFeeFrozen: '物流費凍結額:{count}元',
        frozenQuantity: '凍結件数',
        operator: '演算子',
        operationTime: '稼働時間',
    },

    shopDetail: {
        salesPromotion:'この商品はセール中です',
        endTime:'それまでは',
        month:'月',
        day:'日',
        productPriceException:'商品の価格が異常ですので、カスタマーサービスまでお問い合わせください',
        shippingTips:'納期は個数に関係し、実際の納期に応じます!',
        noSizeWeightInfo:'サイズと重量の情報はまだありません!',
        weightIncludePackaging:'重量(梱包含む)',
        shippingCenter:'フルフィルメントセンター',
        viewAddress:'アドレスを表示',
        color:'色',
        size:'大きさ',
        priceTip:'現在の商品の色やサイズが異なると製造コストが異なるため、単価も異なります',
        noSizeInfo:'サイズ情報はまだありません!',
        amazonSameProduct:'Amazonで同じ商',
        design:'デザインしたい',
        awayup:'すぐに発売',
        basicInfo:'基本情報',
        otherDescription:'其他描述',
        designDescription:'その他の説明',
        sizeInfo:'サイズ情報',
        packageInfo:'梱包情報',
        name:'名前',
        englishName:'英語名',
        productCode:'製品コード',
        productMaterial:'製品素材',
        productCraft:'製品工艺',
        factory:'製造工場',
        shippingTime:'配送予定日数',
        hour:'時間',
        notice:'手記',
        noticeText:'この写真に示されている効果は参考用であり、最終的な効果は実際の製品によって異なります。 生産バッチや機械設備などの客観的な要因により、回避が困難であるか、わずかな色の違い、位置、サイズなどのエラーが生じます。',
        materialDescription:'材料の説明',
        accessoryConstruction:'継手構造',
        productPerformance:'製品性能',
        applicableScenarios:'適用可能なシナリオ',
        washDescription:'洗濯方法について',
        specialNotice:'特別注意事項',
        designArea:'設計領域',
        imageRequirements:'画像要求',
        packageSizeCm:'梱包サイズ（cm）',
        lengthWidthHeight:'（長*幅*高）',
        packageSizeIn:'梱包サイズ（in）',
        packageVolumeCm3:'梱包体積（cm³）',
        packageVolumeIn3:'梱包体積（in³）',
        weightIncludePackagingG:'梱包重量（g）',
        weightIncludePackagingLb:'梱包重量（lb）',
        orderNow: "今すぐ注文、{time}時間以内に配達予定",
        costCalculation:'コスト試算',
        packingName: '梱包名称',
    },

    order: {
        order:'注文',
        myOrder:'私の注文',
        orderExpiration:'30日以上未処理の注文は自動的にキャンセルされます',
        authorizationExpires:'{ expired_nums }店舗認証が期限切れです',
        auditApplicationDesign:'審査申請デザイン',
        mergeOrderList:'マージ可能な配送リスト',
        multipleSearchItems:'複数の検索項目を入力してください（コンマまたはEnterキーで区切る）、最大100件まで',
        clear:'クリア',
        close:'閉じる',
        search:'検索',
        preciseSearches:'正確な検索',
        systemOrderNumber:'システム注文番号',
        platformOrderNumber:'プラットフォーム注文番号',
        orderProductName:'注文製品名',
        createUser:'作成ユーザー',
        operator:'オペレーター',
        designer:'デザイナー',
        customSKU:'カスタムSKU',
        customOrderDetails:'カスタム注文詳細',
        thirdPartyLogistics:'3rdパーティ物流',
        walmartPurchaseNumber:'Walmart購入番号',
        mergeBatchNumber:'マージバッチ番号',
        selectSubAccount:'サブアカウントを選択',
        all:'全て',
        pleaseSelectCraft:'請選擇手工芸',
        logisticsMergeInfo:'物流マージ情報',
        logisticsNotMerged:'物流未マージ',
        logisticsMerged:'物流マージ済',
        choose:'選択してください',
        importDate:'システムが作られた時期',
        payProductionTime:'支払い時間',
        platformOrderTime:'プラットフォーム注文時間',
        platformShippingTime:'プラットフォーム配送時間',
        updateTime:'更新時間',
        systemShippingTime:'システム配送時間',
        startTime:'開始時間',
        endTime:'終了時間',
        to:'至',
        pleaseSelectPlatform:'プラットフォームを選択してください',
        pleaseSelectStore:'店舗を選択してください',
        whetherHasLabel:'ラベルがあるかどうか',
        hasLabel:'ラベルあり',
        noLabel:'ラベルなし',
        noImage:'画像なし',
        productName:'製品名',
        SKUItemNumber:'SKU商品番号',
        specification:'仕様',
        quantity:'量',
        associatedProducts:'関連製品',
        exceptionOrderProducts:'例外注文製品',
        compositeProducts:'合成製品',
        designInProcess:'デザイン中',
        name:'名前',
        price:'価格',
        quantityEdit:'数量編集',
        stockUpProductSKU:'在庫追加製品SKU',
        stockUpInventory:'在庫追加',
        productNumber:'製品番号',
        compositeProductID:'合成製品ID',
        craft:'手工芸',
        size:'サイズ',
        platformSize:'プラットフォームサイズ',
        status:'状態',
        expectedDeliveryTime:'预计交货时间',
        customInfo:'カスタム情報',
        goToDesign:'デザインに進む',
        modifyAssociated:'関連付けを修正',
        applyDesign:'デザインを申請',
        deleteOrderProduct:'注文製品を削除',
        viewProductionNotes:'製品の製造注記を表示',
        productPayment:'製品货款',
        shippingFee:'配送料',
        frozenShippingFee:'凍結配送料',
        total:'合計',
        profitMargin:'利益マージン',
        contactPerson:'連絡先人物',
        contactPhone:'連絡先電話番号',
        warehouseAddress:'倉庫住所',
        trackingNumber:'トラッキング番号',
        shippingDays:'配送日数',
        deliveryDays:'納品日数',
        logisticsNotUpdated:'物流{days_after_last_update}日未更新',
        logisticsTrack:'物流追跡',
        platformLatestShippingTime:'プラットフォーム最新配送時間',
        importSystemTime:'インポートシステム時間',
        productPaymentTime:'製品付款時間',
        copyOrder:'注文をコピー',
        createPreShipping:'前配送を作成',
        handleException:'例外を処理',
        applyAfterSales:'後販申請',
        getTrackingNumber:'トラッキング番号を取得',
        modifyAddress:'住所を修正',
        restoreOrder:'注文を復元',
        cancelOrder:'注文をキャンセル',
        applyInterception:'傍受を申請',
        syncLogistics:'物流を同期',
        viewLabel:'ラベルを表示',
        orderDetails:'注文詳細',
        shippingMethod:'配送方法',
        FBAShipping:'FBA配送',
        selfPickup:'自己取り',
        suspectedPhishing:'疑わしい_phishing',
        phishingAddress:'フィッシングアドレス',
        shippingCenter:'配送センター',
        platform:'プラットフォーム',
        store:'店舗',
        receiver:'受取人',
        phoneNumber:'電話番号',
        recipient:'受取人',
        postCode:'郵便番号',
        detailedAddress:'詳細住所',
        detailedAddress2:'詳細住所2',
        salesVolume:'売上高',
        logistics:'物流',
        time:'時間',
        operation:'操作',
        createShipping:'作成配送',
        enterProductionInfo:'製造情報を入力',
        mergeShipping:'配送をマージ',
        batchCreateShipping:'バッチ作成配送',
        importCustomInfo:'カスタム情報をインポート',
        generateFBAItem:'FBA商品の生成',
        modifyProductQuantity:'注文商品数量の変更',
        syncFullCustodyShipping:'完全な保管出荷の同期',
        createOut:'作成',
        payProductPayment:'商品代金の支払い',
        batchImportLabels:'ラベルのバッチインポート',
        importLogisticsNumber:'輸入物流番号',
        importOrder:'輸入訂單',
        mergeShipping1:'マージ配送',
        createFBAItem:'FBA商品の作成',
        sheinCustomInfo: "Sheinのカスタマイズ情報",
        temuCustomInfo: "Temuのカスタマイズ情報",
        logisticsExport:'輸出',
        walmartLogisticsExport:'ウォルマートの注文に物流情報を更新',
        moreOperation:'その他の操作',
        batchExportOrders:'バッチエクスポート注文',
        batchPreShipping:'バッチプリシャッシュ',
        batchCancelOrder:'バッチキャンセル注文',
        exportShippingCost:'出荷費用のエクスポート',
        country:'国',
        city:'都市',
        state:'州',
        mailbox:'メールボックス',
        quantitySelected:'{ count } の注文が選択されました',
        payableNum:'{ count } の注文は支払い可能です',
        unPayableNum:'{ count } の注文は支払い不可能です',
        resultPreview:'結果のプレビュー',
        payable:'支払い可能',
        unPayable:'支払い不可能',
        orderNumber:'注文番号',
        orderPayment:'注文支払い',
        viewDetail:'詳細を表示',
        orderProduct:'注文製品',
        unitPrice:'単価(￥)',
        totalPayment:'合計支払い(￥)',
        orderStatus:'注文状態',
        description:'説明',
        paymentMethod:'支払い方法',
        accountBalance:'アカウント残高',
        availableBalance:'利用可能残高(￥)',
        recharge:'充值',
        payableAmount:'支払い可能額(￥)',
        pay:'支払い',
        pleaseSelectOrder:'注文を選択してください',
        orderPaymentException:'注文の支払い金額に異常があります。お客様に連絡してください。',
        payOrderPayment:'注文の支払い金額を支払いますか？',
        mergedShippingSameStoreSameAddress:'マージ配送は同じ店舗で同じ住所を購入する必要があります',
        orderID:'注文ID',
        platformStore:'プラットフォーム店舗',
        requiredShippingTime:'要求配送時間',
        copyAllOrderID:'すべての注文IDをコピー',
        ShippingTimeRequired:'要求配送時間は必須です',
        Shein:'Shein',
        Temu:'Temu',
        shippingOrderCreateTime:'配送注文作成時刻',
        endDate:'終了日',
        startDate:'開始日',
        whetherCover:'完全な保管出荷の同期を上書きしますか？',
        pleaseSelectSyncTime:'同期時刻を選択してください',
        productFnsku:'製品fnsku',
        platformSku:'プラットフォームSKU',
        generateTip:'* 詳しくはFBA=»配送リストをご覧ください',
        pleaseSelectType:'タイプを選択してください',
        shipmentInfo:'配送情報',
        importTrackingNum: '輸入物流番号',
        orderProducts:'注文製品',
        systemNoOrderID:'システムに注文番号がありません',
        systemHasLogisticsNumber:'システムに物流番号があります',
        procedureTip:"手順: サードパーティ プラットフォームのバックグラウンドにログインして、出荷する必要がある顔注文をダウンロードし、顔注文ファイルの名前は「プラットフォーム注文number{'@'}waybill番号」です。インポートされた注文フォームにすでに追跡番号が含まれている場合は、追跡番号で直接名前を付けることができます (請求書がすでに存在する場合、新しくインポートされた注文は元の注文をカバーします)USPS フェイスシートの推奨サイズ: 4*6インチ",
        procedureTip1:'手順:テンプレートをダウンロードし、インポートするプラットフォーム注文番号とロジスティクス注文番号を入力します。次に、フェイスオーダーファイルに運送状number.pdfという名前が付けられ、フェイスオーダーファイルのアップロードを続行します',
        goImportLogisticsNumber:'物流番号をインポート',
        keywordSearch:'キーワードクイック検索',
        dragAndDropFile:'ファイル物流面单PDFファイルをここにドラッグアンドドロップしてアップロード',
        clickUpload:'クリックアップロード',
        pleaseUploadPDFFile:'PDFファイルをアップロードしてください',
        successfullyImported:'成功にインポート { count } 注文',
        failedImport:'{ count } 注文のインポートに失敗',
        failedReason:'失敗の理由',
        pleaseUploadWaybill:'面单をアップロードしてください',
        pleaseUploadTxtXlsxXlsFormat:'.txt、.xlsx、.xls形式のファイルをアップロードしてください',
        pleaseUploadCustomInfoFile:'カスタマイズした情報ファイルをアップロードしてください',
        downloadTemplate:'ダウンロードテンプレート',
        import:'インポート',
        pleaseImportLogisticsNumber:'物流番号をインポートしてください',
        logisticsChannels:'ロジスティクスチャネル',
        deliver:'配送方式',
        goChannel:'物流渠道を設定する',
        logisticsNumber:'物流番号',
        logisticsWaybill:'ロジスティクスシート',
        importLogisticsWaybill:'物流面单をインポート',
        pleaseUploadLogisticsWaybill:'物流面单をアップロードしてください。PDF,.zip形式',
        systemAgent:'システム代理',
        ownChannel:'自社渠道',
        proxyChannel:'代理渠道',
        confirmDesignComplete: '製品のステータスは設計完了であり、カスタマイズされた情報製品の変更を再設計する必要があります。?',
        preShippingCreated:'出荷前を変更する必要がある場合は、プラットフォームのカスタマーサービスにお問い合わせください',
        orderInfo:'注文情報',
        shippingAddress:'配送先住所',
        customsInformation:'税関情報',
        logisticsInformation:'物流情報',
        transactionInformation:'取引情報',
        exceptionOrderProduct:'異常注文商品',
        combinedProduct:'組み合わせ製品',
        orderProductIdentifier:'注文製品識別子',
        stock:'在庫',
        combinedProductID:'組み合わせ製品ID',
        productionStatus:'製造状態',
        goProductionTime:'製造開始時刻',
        deliveryTime:'納品時刻',
        pendingProcessing:'待処理',
        designInProgress:'設計',
        designComplete:'設計完了',
        inProduction:'製造中',
        qualityInspection:'品質検査中',
        pendingShipping:'待出荷',
        delivered:'出荷済み',
        cancelled:'キャンセル済み',
        shipping:'出荷中',
        remoteAddress: 'リモートアドレス',
        province: '州',
        pleaseCorrectEmailAddress: 'Please enter the correct email address',
        selectedProductName: 'Selected product name',
        chineseName: '中国名',
        englishName: '英語名',
        material: '材料',
        declarePrice: '申告価格',
        declareWeight: '申告重量 (g)',
        customsCode: '税関コード',
        remark: '注釈',
        declareRemark: 'プラットフォームは製品の税関申告情報を事前に設定し、代理店として注文を申告します。税関申告または税関差し押さえによって生じた紛争/損失については、ユーザーが責任を負います。',
        declareRemark1: '製品の税関申告情報をカスタマイズできます',
        declareRemark2: '(同じブランク製品、複合申告)',
        clickGo: 'クリックして行く',
        createLogisticsNumber: '物流番号を作成',
        recentLogisticsTrack: '最近の物流追跡',
        transactionType: '取引種類',
        transactionNumber: '取引番号',
        amountInYuan: '金額 (元)',
        factoryOrderNumber: '工場注文番号',
        arrivalTime: '到着時刻',
        frozenType: '凍結種類',
        OrderLogisticsFee: '注文物流料金',
        frozenQuantity: '凍結数量',
        frozenAmountInYuan: '凍結金額 (元)',
        operationTime: '操作時刻',
        reDesign: '再設計',
        copyOrderConfirm: 'コピー注文、続行しますか?',
        getWaybillNumber: 'パーセル番号を取得、続行しますか?',
        deleteOrderProductConfirm: '注文商品を削除 (注文に製品がない場合は注文も削除されます!)、続行しますか?',
        recoverOrderToPendingProcessing: '注文を待処理に回復、続行しますか?',
        batchCancelOrderConfirm: 'バッチキャンセル注文、続行しますか?',
        syncLogisticsConfirm: '物流を同期、続行しますか?',
        syncLogisticsTip: '選択した項目にはFBA出荷注文が含まれていません',
        cancelOrderConfirm: '注文をキャンセル、続行しますか?',
        cancelOrderTip: '注文が処理済みであるため、キャンセルすると工場料金が引き落とされます。続行しますか?',
        Y2OrderCancelConfirm: 'Y2注文をキャンセル、続行しますか?',
        synchronousTKFaceSheet: 'TK面单を同期',
        batchGetTKFaceSheetConfirm: 'TK面单をバッチ取得、続行しますか?',
        batchGetTEMUFaceSheetConfirm: 'TEMU面单をバッチ取得、続行しますか?',
        reDesignBindProductWillUnbind: '再設計後、バインド製品は自動的に解除されます',
        pleaseNote: '予めご了承ください',
        pleaseNoteTip: '新しく開いたページで製品デザインを完了し、事前にこのウィンドウを閉じた場合は、デザイン後に手動でページを更新してください。',
        tipsWarmPrompt: '警告提示',
        pleaseNoteTip1: 'カスタム請求書をアップロードする必要がある場合は、支払い前に作成してください。',
        batchExportProduct: 'バッチ製品情報をエクスポート',
        keywordSearches: '最大100のキーワード検索をサポートします',
        logisticsFiveNotUpdated: '物流情報は5日間更新されていません',
        platformOrder: 'プラットフォーム注文',
        mergeShippingList: '出荷リストをマージ',
        pleaseNoteLogisticsWaybill: '物流注文は2回しか閲覧できないのでご注意ください。続行すれば?',
        platformSearch: 'プラットフォーム検索',
        addStore: '新店舗',
        importQuantity: 'インポート数量',
        skipQuantity: 'スキップ数量',
        file: 'ファイル',
        fileDownload: 'ファイルダウンロード',
        account: 'アカウント',
        createTime: '作成時刻',
        getTEMUSheetsInBulk: 'バッチでTEMU面单を取得',
        getOZONSheetsInBulk: 'バッチでOZON面单を取得',
        OZONBulkMarkShipments: 'OZONバッチで出荷をマーク',
        goodsID: '商品ID',
        mergeOrder: '注文をマージ',
        pleaseSelectSameStoreOrder: '同じ店舗の注文を選んでください',
        mergeOrderConfirm: '注文をマージした後は、合併した注文は削除され復元できず、マージは続行されますのでご注意ください?',
        splitOrder: '分割注文',
        productQuantity: '製品数量',
        splitQuantity: '分割数量',
        split: '分割',
        product: '製品',
        sizeInfo: 'サイズ情報',
        color: '色',
        pleaseSelectColor: '色を選択してください',
        pleaseEnterQuantity: '数量を入力してください',
        waybillNumber: 'パーセル番号',
        pdfType: 'PDF タイプ',
        storneTip: 'そうしなくても、当座預金口座で出された該当する注文はデフォルトで取得されます',
        storeremark: '備考情報：現在のアカウント下の対応する注文情報を更新する（デフォルト）。店舗を選択すると、現在のアカウント下の対応する店舗の注文データのみ更新されます。ウォルマートプラットフォームの注文には重複がある可能性があるため、店舗の選択をお勧めします',
        pleaseUploadFaceSheet: 'フェイスシートをアップロードしてください',
        afterSaleType: '後払い種類',
        refundTip: '返金(返品を受け取っていないか、返品しない交渉で返金のみ)',
        returnRefundTip: '返金(返品を受け取った場合、ダメージ、送り間違いなど)',
        reissueTip: '再発行(返品を受け取った場合、ダメージ、送り間違いなど)',
        refundType: '返金種類',
        onlyRefundPayment: '返金のみ(配送料金は返金しません)',
        onlyRefundShippingFee: '返金のみ(配送料金は返金しません)',
        refundPaymentAndShippingFee: '返金(配送料金を含む)',
        refundAmount: '返金額',
        productionFee: '支払い金額',
        afterSalesProduct: '後払い製品',
        totalQuantity: '合計数量',
        afterSalesQuantity: '後払い数量',
        uploadVoucher: 'ボーナス券をアップロード',
        uploadVoucherTip: 'ボーナス券をアップロードしてください。プラットフォームはボーナス券を審査し、ボーナス券に基づいて返金を行います。サポートフォーマット：JPG、PNG',
        voucherDescription: '* 迅速なレビューのためにバウチャーの説明をご用意ください。以下のバウチャーをアップロードしてください',
        contactWay: '連絡先',
        aftersalesReason: '後払い理由',
        qualityProblem: '品質問題 (ダメージ、品質が悪い)',
        printingProblem: '印刷問題 (印刷品質が悪い、上書き印刷、印刷が間違っている)',
        lessQuantity: '数量不足 (間違った商品を送った、数量不足)',
        notReceived: '未受取',
        refundDifference: '返金差額',
        other: 'その他',
        afterSalesDescription: '後払い説明',
        platformOrderScreenshot: 'プラットフォーム注文詳細スクリーンショット',
        platformRefundScreenshot: 'プラットフォーム返金申請成功スクリーンショット',
        customerRefundEmailScreenshot: '顧客返金申請メールスクリーンショット',
        packagingPhysicalImage: '包装物理画像',
        productPhysicalImage: '製品物理画像',
        salesInfo: '販売情報',
        purchaseAmount: '購入金額',
        currency: '通貨',
        salesTotal: '売上総額',
        expectedPayment: '予想返金額',
        addressSmartParsing: '住所の智能解析',
        addressInfoAutoFill: '住所情報自動入力',
        pasteFullAddressInfo: '住所情報をペースト',
        parseAddress: '住所を解析',
        automaticParsing: '自動解析',
        stateProvince: '州/都道府県',
        email: 'メールアドレス',
        phone: '電話番号',
        addressDetail: '住所詳細',
        submit: '提出',
        confirmSubmit: 'システムが自動的に認識した結果が正しいことを確認してください。続行しますか?',
        mergeOrderTip: 'ご注意ください! 現在の注文はすでに統合出荷の一部であり、統合バッチ全体に対して出荷が作成されます',
        expressOrderTip: '急件！現在の注文は急件注文であり、急件配送チャネルを選択してください',
        channel: 'チャンネル',
        recipientCountry: '受取国',
        totalWeight: '合計重量',
        totalVolume: '合計体積',
        logisticsWaybillSearch: '物流手法のキーワード検索',
        expectedFee: '推定費用',
        deliveryRate: '成功率',
        foreignChannel: '海外チャンネル',
        orderNotHaveProductTip: '注文に商品がなければ、総出荷重量や推定物流コストは計算できません',
        customDelivery: 'カスタム出荷',
        channelName: 'チャンネル名',
        pleaseSelectLogisticsChannel: '物流方式を選択してください',
        logisticsWaybillNumber: '物流番号',
        logisticsFaceSheet: '物流面单',
        importLogisticsFaceSheet: '物流面单をインポート',
        pleaseUploadPdfFormat: 'PDF形式の物流面单をアップロードしてください',
        pleaseEnterIos: 'iossを入力してください',
        calculateShippingFeeTip: '現時点では、米国地区のみの配送料試算を提供しています。試算配送料、妥投时效、妥投率は参考用であり、售后赔付標準としては使用しないでください',
        customChannelTip: 'カスタムチャンネルを使用する場合は、完全な情報を入力してください！！！',
        pleaseSelectShippingWay: '先に出荷方式を選択してください！！',
        specialOrderCancel: '特殊注文のキャンセルは、サポートチームに連絡してください',
        mergeOrderCancelTip: '注意：この注文はすでに統合出荷の一部であり、統合バッチ全体に対して出荷が作成されます。注文をキャンセルすると、関連注文も自動的にキャンセルされます',
        goodsHandlingMethod: '商品処理方法',
        factoryDestroy: '工場破棄',
        returnToSpecifiedAddress: '寄回指定アドレス',
        myAddress: '私の住所',
        pleaseSelectReturnAddress: '寄回指定アドレスを選択してください',
        addAddress: '新しい住所を追加',
        orderCancelDetail: '注文取消詳細',
        expect: '推定',
        refund: '返金',
        deduct: '引き落とし',
        orderCancelFeeDetail: '注文取消各種料金明細',
        orderCancelFeeStandard: '注文取消料金標準',
        returnToSpecified: '寄回指定アドレス料金標準',
        returnToSpecifiedAddressTip: '注文製品は製造完了後、寄回指定アドレスに送られ、全製造費用を受取ります',
        factoryDestroyFeeStandard: '工場破棄料金標準',
        factoryDestroyTip: '待処理免費取消',
        craftsmanship:'直噴、オフセット印刷、印刷、広告プロセス',
        factoryDestroyTipDetail: '保留中の無料を除き、その他のステータスは全額請求されます',
        productionProcessTip: '製造プロセスが待処理（不包含）と半成品（包含）の間にある場合、製造費用の50％が引き落とされ、50％が返金されます。',
        productionProcessTip2: '製造プロセスが半成品（不包含）と待成品の間にある場合、製造費用の80％が引き落とされ、20％が返金されます。',
        productionProcessTip3: '外部工場注文では、待処理免費を除き、その他のステータスは全額請求されます。',
        productionProcessTip4: '米国の工場発注はキャンセルや返品ができません',
        pleaseSelectReturnAddressTip: '寄回指定アドレスを選択してください',
        cancelOrderConfirmTip: '注文をキャンセルすると、工場が已製作の製品を製造完了した場合、製造費用が引き落とされます。操作は一旦行われ、後で撤回することはできません。本操作を続行しますか?',
        sendBackTip: 'ご注意ください!米国の工場で製造され、指定された住所に返送できません',
        goodsHandled: '商品処理方法',
        pleaseSelectAddress: '住所を選択してください',
        temuRepository:'Temuプラットフォームのリポジトリが選定されました',
        temuLogistics:'Temuプラットフォームの半自動物流が選定されました',
        warehouse:'倉庫',
        logisticsChannel:'物流チャネル',
        batchGetShopeeWaybill:'バッチでShopeeプラットフォームの面单を取得',
        shippingInformation:'配送情報'
    },

    process: {
        order: '加工注文',
        processOrder: '加工注文',
        productionStatus: '製造状態',
        inProduction: '製造中',
        productionComplete: '製造完了',
        cancel: 'キャンセル',
        processedProduct: '加工製品',
        elementPicture: '要素画像',
        processedQuantity: '加工数量',
        craft: '工艺',
        whiteInkTemperingPainting: '白墨烫画',
        chiffonDyeing: '密绣',
        pasteFabDyeing: '贴布绣',
        knittedCapSeamMarking: '针织帽缝标',
        status: '状態',
        remark: '注釈',
        creator: '作成人',
    },

    intercept_order: {
        order: '注文',
        logisticsInterception: '物流中断',
        orderNumber: '注文番号',
        status: '状態',
        pending: '待処理',
        interceptionSuccess: '中断成功',
        interceptionFailed: '中断失敗',
        completed: '完了',
        applyStartTime: '申請開始時刻',
        applyEndTime: '申請終了時刻',
        processingMethod: '処理方法',
        factoryDestroy: '工場破壊',
        returnToSpecifiedAddress: '指定住所に返送',
        viewAddress: '住所を表示',
        logisticsNumber: '物流番号',
        logisticsFee: '物流料金',
        applyPerson: '申請人',
        applyInterceptionTime: '申請中断時刻',
        operation: '操作',
        log: 'ログ',
        pleaseSelectStatus: '状態を選択してください',
        cancelSuccess: '中断キャンセル成功',
        cancelFailed: '中断キャンセル失敗',
        pleaseSelectProcessingMethod: '処理方法を選択してください',
        interceptionSuccessQuantity: '中断成功数量',
        interceptionFailedQuantity: '中断失敗数量',
        cancelInterception: '中断キャンセル',
        interceptionProgress: '中断進捗',
        cancelInterceptionConfirm: '中断キャンセル、続行しますか?',
        date: '日付',
        userName: 'ユーザー名',
        progress: '進捗',
    },

    temu_custom: {
        order: '注文',
        importTEMUCustomInfo: 'TEMUカスタマイズ情報のインポート',
        importCustomInfoZip: 'カスタマイズ情報（Zip）のインポート',
        importCustomInfoExcel: 'カスタマイズ情報（Excel）のインポート',
        status: '状態',
        unparsed: '未解析',
        parsed: '解析済み',
        store: '店舗',
        file: 'ファイル',
        fileDownload: 'ファイルダウンロード',
        operation: '操作',
        analysisCustomization: '解析カスタマイズ',
        importCustomInfo: 'カスタマイズ情報のインポート',
    },

    afterSalesList:{
        order: '注文',
        afterSalesManagement: 'アフターセールス管理',
        orderNumber: '注文番号',
        afterSalesType: 'アフターセールス種類',
        refund: '払い戻す',
        returnRefund: '返品の返金',
        resend: '再送',
        pending: '待処理',
        confirmed: '確認済み',
        completed: '完了',
        auditPassed: '審査通過',
        auditRejected: '審査却下',
        afterSalesOrderInfo: 'アフターセールス注文情報',
        productName: '商品名',
        productImage: '商品画像',
        afterSalesAmount: 'アフターセールス金額 (元)',
        applyAfterSalesAmount: 'アフターセールス金額の適用',
        actualAfterSalesAmount: '実際のアフターセールス金額',
        afterSalesReason: 'アフターセールス理由',
        afterSalesInstruction: 'アフターセールス手順',
        submitPerson: '提出人',
        updateTime: '更新時刻',
        operation: '操作',
        view: '表示',
        viewAfterSalesDetail: 'アフターセールス詳細を表示',
    },

    blackList:{
        blackList: 'ブラックリスト',
        addressBlacklist: '住所ブラックリスト',
        clientBlacklist: '顧客ブラックリスト',
        ruleName: 'ルール名',
        contain: '含む',
        equal: '等しい',
        operationInfo: '操作情報',
        operationPerson: '操作人',
        createInfo: '作成情報',
        createPerson: '作成人',
        embodyTip: '含む: フレーズの 1 つに一致するだけで済みます。Equal: すべてのフレーズに一致する必要があります',
        blackListAddTip: 'ブラックリストの入力が完了しました。Enterキーを押して追加してください',
        tagAddTip: 'タグの入力が完了しました。Enterキーを押して追加してください',
        remark: '注釈',
        provinceState: '都道府県/州',
        city: '市',
        address: '住所',
        postcode: '郵便番号',
        store: '店舗',
    },

    store: {
        storeManagement: '店舗管理',
        normalStatus: '正常',
        disabledStatus: '無効にする',
        storeName:'店舗名',
        pleaseEnterStoreName: '店舗名を入力してください',
        pleaseSelectCountry: '国を選択してください',
        authorizationStatus: '認証状態',
        addStore: '新しい店舗を追加',
        editStore:'店舗を編集',
        storeInfo: '店舗情報',
        platform: 'プラットフォーム',
        status: '状態',
        defaultShippingWarehouse: 'デフォルトの出荷倉庫',
        syncInfo: '同期情報',
        delayTimeForOnlineOrders: 'オンライン注文の履行遅延時間',
        productSKUAssociation: '製品SKU関連付け',
        operator: '演算子',
        createTime: '作成時間',
        operation: '操作',
        authorized: '承認',
        unauthorized: '不正',
        authorizationException: '承認例外',
        noAuthorizationRequired: '承認は不要',
        exceptionReason: '例外の理由',
        reset: 'リセット',
        fullCustody:'完全な保管',
        halfCustody:'半分の親権',
        email:'電子メール',
        firstSyncTime:'最初の同期時刻',
        edit:'編集',
        complianceFile:'コンプライアンス文書',
        uploadComplianceFile: 'ファイルをアップロードする',
        shippingConfiguration:'出荷構成',
        more:'もっとその',
        licensedByShein:'Sheinによるライセンス',
        cancelAuthorization:'承認のキャンセル',
        shopProducts:'店舗商品',
        addMallID:'mallid の追加',
        delete:'削除',
        number:'ナンバリング',
        region:'地域',
        brand:'ブランド',
        automaticallySyncOrders:'注文を自動的に同期する',
        yes:'はい',
        no:'いいえ',
        syncOrderStatus:'注文ステータスの同期',
        pendingProcessing:'ペンディング',
        pendingShipping:'発送予定',
        ifBoundShippingCenter:'フルフィルメントセンターがバインドされている場合は、フルフィルメントセンターに従って倉庫が照合され、バインドがない場合はデフォルトでデフォルトの倉庫が取得されます',
        pleaseSetWarehouse:'リポジトリを設定してください',
        all:'すべての',
        continue:'続ける',
        cancel:'キャンセル',
        deleteStoreTip:'削除後にストアを復元できない場合、ストアは継続されますか?',
        operationSuccess:'作戦は成功しました',
        cancelAuthorizationTip:'ストア認証をキャンセルしますが、続行しますか?',
        product:'プロダクツ',
        day:'日',
        pleaseSelectPlatform:'プラットフォームを選択してください',
        hostingMethod:'ホスティング方法',
        productInventoryToken:'製品在庫トークン',
        getProductInventoryToken:'TEMU卖家中心に入る【サービスマーケット-認証管理】から製品在庫トークンを取得する',
        getToken:'製品在庫トークンを取得する',
        orderShippingToken:'注文出荷トークン',
        US:'米国',
        goToSellerCentralUS:'米国Seller Centralに入る',
        global:'全世界(米国、ヨーロッパを除く)',
        goToSellerCentralGlobal:'全世界Seller Centralに入る（米国、ヨーロッパを除く）',
        EU:'ヨーロッパ',
        goToSellerCentralEU:'ヨーロッパSeller Centralに入る',
        country:'国',
        affiliatedOperator:'提携事業者',
        pleaseSelectOperator:'提携事業者を選択してください',
        storeBrand:'店舗ブランド',
        pleaseEnterStoreBrand:'店舗ブランドを入力してください',
        storeEmail:'店舗メール',
        pleaseEnterStoreEmail:'店舗メールを入力してください',
        pleaseEnterFirstSyncTime:'最初の同期時刻を入力してください',
        SKUItemNumber:'SKU商品番号',
        hour:'時間',
        onlineOrderImmediateDelivery:'オンライン注文を受け取ったら即時出荷',
        onlyUseUSPS:'USPSのみが使用されます',
        pleaseEnterCountry:'国を入力してください',
        pleaseSelectStatus:'ステータスを選択してください',
        pleaseSelectAutoSyncOrders:'注文を自動的に同期するかどうかを選択してください',
        pleaseEnterValidEmail:'有効なメールアドレスを入力してください',
        pleaseSelectProductSKUAssociation:'製品SKU関連付けを選択してください',
        pleaseSelectOnlineOrderDelayTime:'オンライン注文の履行遅延時間を選択してください',
        pleaseSelectHostingMethod:'ホスティング方法を選択してください',
        pleaseEnterProductInventoryToken:'製品在庫トークンを入力してください',
        pleaseSelectSyncOrderStatus:'注文同期ステータスを選択してください',
        pleaseDoNotSubmitAgain:'注文同期ステータスを選択してください',
        pleaseEnterOrderShippingToken:'注文出荷トークンを入力してください',
        priceStepGetTip:'[価格段階取得] 一部の物流は未受取問題が発生した場合、2回目の出荷を計画しています。顧客は自己責任でコストを負担してください。続行しますか？',
        notice:'手記',
        shippingMethod:'出荷方法',
        priceStepGetTip1:'価格帯の獲得 (最低価格のチャネル ロジスティクスの既定の獲得)',
        priceStepGetTip2:'Yanwen の収集率は非常に低いため、このアイテムは Yanwen Logistics を除外します',
        priceStepGetTip3:'*未回収による物流上の問題により、一度補う手配をさせていただき、未回収の問題が再び発生します。お客様は、ご自身の責任において責任を負います。',
        pleaseEnterKeyword:'商品SKUを入力してください',
        productsSKU:'商品SKU',
        relatedProducts:'関連商品',
        productName:'商品名',
        unbind:'解除',
        unbindProductTip:'商品を解除しますか？',
        sync:'倉庫同期',
        warehouseName:'倉庫名',
        defaultWarehouse:'デフォルト倉庫',
        warehouseCode:'倉庫コード',
        correspondingShippingFactory:'対応出荷工場',
        setDefault:'デフォルト倉庫を設定',
        setFactory:'出荷工場を設定',
        setDefaultWarehouseTip:'デフォルト倉庫を設定しますか？',
        TemuSynchronizationTip:'Temuストア倉庫の同期、続きますか?',
        pleaseEnterMallID:'マルケットIDを入力してください',
        TKAuthorization: 'TK 認可',
        warning: '警告',
        authorizationTip: 'ログイン Tik Tok ストアの IP の問題を考慮すると、このリンクを VPN またはサードパーティのブラウザにコピーして操作することをお勧めします',
        description: '説明: グローバル加盟店または英国への国境を越えた国内加盟店の場合は、',
        description1: 'Asia ---> Chinese mainland and the Hong Kong SAR (Cross-Border only)',
        copy: '写し',
        close: '閉じる',
        storeType: '権限タイプ',
        USCrossBorder: '米国（跨境）',
        PhilippinesCrossBorder: 'フィリピン（跨境）',
        continentalUnitedStates:'アメリカ合衆国(本土)',
        factory: '工場',
        notAmerican: "アメリカ人じゃない",
        onlineOrderDelayTime: '注文遅延時間',
        synchronizeInfo: '同期情報',
        nationalTip:'工場は選ばれた国に合わせて同期されています',

        importOrderTip: 'ご注意ください! プラットフォームの注文フォームの変更により、輸入後に注文情報および住所情報をご確認ください',
        importMethod: '輸入方式',
        importPlatformOrder: '輸入平台注文',
        importOfflineOrder: '輸入线下注文',
        ImportMethod: '輸入方式',
        importOrder: '輸入注文',
        FileFormatTip: '請上傳.txt, .xlsx, .xls格式',
        orderImportTemplate: 'オフライン取引注文インポートテンプレート.xlsx',
        amazonOrderDownloadPath: 'Amazon注文ダッシュボードダウンロードパス:注文レポート - 》 新しい注文',
        amazonOrderDownloadConfig: 'Amazon注文ダッシュボードダウンロード設定: 注文レポート - 》 新しい注文',
        ebayOrderImportEnglish: 'ebay注文 インポート英語版注文',
        bindProductTip: 'プラットフォームSKUが複数の異なる商品にバインドする必要がある場合は、注文をインポートし、「Operation - 》をクリックして商品をリバインドしてください',
        pleaseUploadFile: '請上傳文件',
        pleaseEnterStoreNumber: '請輸入店铺編號',
        pleaseSelectStore: '請選擇店铺',
        checkImportOrderTip: '輸入後請仔細核对產品信息和收貨地址信息',
        noticeTip: '注記',
        confirm: 'もう知ってるよ',
        skipImportTip: '{skip_nums}件の注文がインポートをスキップしています',
        productAPI: '製品API',
        productAPIAuthorization: '製品API認証',
        goAuthorization: '去認証',
        USOrderAPIAuthorization: '美区注文API認証',
        EUOrderAPIAuthorization: '欧区注文API認証',
        globalOrderAPIAuthorization: '全球注文API認証',
        temuShopType: 'Temu店舗種類',
        fullTruck: '完全な親権',
        halfTruck: 'セミエスクロー',
        productToken: '製品token',
        orderToken: '注文token',
        authorizationTips:'*Temuが生成したアクセストークンの有効期間は90日で、キーが期限切れの場合は再認証が必要です；',
        pleaseEnterToken: 'トークンを入力してください',
        ozonAuthorization: 'Ozon認可',
        wildberriesAuthorization: 'Wildberries認可',
        userID: 'ユーザー識別番号',
        APIKey: 'APIキー',

        shopeeAuthorization:'Shopee認可'
    },

    merge:{
        order: '命令',
        mergeShippingRecord: '出荷記録の統合',
        batchNumber: 'バッチ番号',
        orderNumber: '注文番号',
        waybillNumber: '出荷伝票番号',
        operator: '運送会社',
        sheinShippingBatchNumber: 'Shein出荷バッチ番号',
        TEMUShippingBatchNumber: 'TEMU出荷バッチ番号',
        logisticsChannel: '物流チャネル',
        store: '店舗',
        createTime: '作成日時',
        requireShippingTime: '出荷日時',
        againMerge: '再統合',
        platformReserveShipping: 'プラットフォーム予約出荷',
        platformShippingBatchNumber: 'プラットフォーム出荷バッチ番号',
        againMergeBatchNumber: '再統合バッチ番号',

        totalMerge: 'マージ合計: { length } 注文、合計数量: { total_quantity } 個',
        orderInfo: '注文情報',
        processQuantity: 'Process/quantity: {render_type}/{quantity} 個',
        shipments: '出荷',
        type: '種類',
        expressOrder: 'Express orders',
        normalOrder: 'Normal orders',
        orderTime: '注文日時',
        requireLatestShippingTime: '出荷日時を要求',
        deliveryDate: '出荷日',
        viewAll: '全て表示',
        operationInfo: '操作情報',
        platform: 'プラットフォーム',
        creator:'運送会社',
        userInfo: 'ユーザー情報',
        userName: 'ユーザー名',
        email: 'メールアドレス',
        recipient: '受取人',
        addressInfo: '住所情報',
        time: '時間',
        operation: '操作',
        cancelAgainMerge: '再統合を取り消す',
        cancelMerge: 'マージを取り消す',
        uploadTEMUExpressFile: 'TEMU 出荷ファイルをアップロード',
        pleaseSelectOrder: '注文を選択してください',
        cancelAgainMergeConfirm: '再統合を取り消す、続行しますか？',
        mergeBatchConfirm: 'マージバッチ、続行しますか？',
        cancelMergeShippingConfirm: 'マージ出荷を取り消す、続行しますか？',
        uploadFiles: 'ファイルをアップロード',
        temuExpressFile: 'TEMU 出荷ファイル',
        pleaseUploadPdfFormat: 'PDF 形式のファイルをアップロードしてください',
        reservePickupTime: '出荷予約時間',
        suggestReservePickupTime: '出荷予約時間を { latest_ship_date } 前に設定することをお勧めします',
        packageTotalQuantity: 'パッケージの合計数量',
        packageWeight: '重量 (kg)',
        estimatedWeight: '推定重量: { estimated_weight }kg',
        logisticsCompany: '物流会社',
        estimatedFee: '推定料金',
        query: 'クエリ',
    },

    main:{
        salesDataOverview:'売上データ概要',
        lastLoginLocation:'最終ログイン地点',
        lastLoginTime:'最終ログイン時間',
        todoItems:'待办事项',
        recent7DaysMetrics:'最近7日間の製品行動指標',
        recommend:'推奨',
        changePassword:'パスワードを変更',
        todaySales:'今日の売上',
        orderCount:'注文数',
        yesterdaySales:'昨日の売上',
        thisWeekSales:'この週の売上',
        thisMonthSales:'この月の売上',
        itemCount:'商品数',
        all:'すべて',
        noNotification:'まだ通知がありません',
        hotRecommend: 'ホット推奨',
        newProductDelivery: '新製品の配送',
        hotSales: 'ホット売上',
        viewDetail: '詳細を表示',
        newProduct: '新製品',
        shippingCenter: '出荷中心',

        designProductQuantity: '設計製品数量',
        designCategoryQuantity: '設計カテゴリ数量',
        elementUploadQuantity: '要素アップロード数',
        designOrderEfficiency: '設計出荷効率',
        categoryOrderEfficiency: 'カテゴリ出荷効率',
        elementOrderEfficiency: '要素出荷効率',
    },

    acInfo: {
        myAccount: 'マイアカウント',
        shippingMethod: '出荷方法',
        downloadCenter: 'ダウンロードセンター',
        roleManagement: 'ロール管理',
        subAccountSetting: 'サブアカウント設定',
        myDistribution: 'マイ配送',
        senderInfo: '寄件人情報',
        userNumber: 'ユーザー番号',
        detailedAddress: '詳細な住所',
        accountNumber: 'アカウント番号',
        changePassword: 'パスワードを変更',
        phone: '電話番号',
        balance: '残高',
        recharge: '入金',
        withdraw: '出金',
        commission: 'コミッション',
        orderCommission: '注文コミッション',
        shippingCommission: '出荷コミッション',
        shippingReturn: '出荷返品',
        withdrawInfo: '出金情報',
        shippingAddress: '出荷先住所',
        name: '名前',
        defaultAddress: 'デフォルト住所',
        country: '国',
        state: '都道府県',
        city: '市',
        area: '区',
        street: '街道',
        postcode: '郵便番号',
        mobilePhone: '携帯電話番号',
        addressDetail: '詳細な住所',
        editAddress: '住所を編集',
        default: 'デフォルト',
        systemChannel: 'システムチャネル',
        ownChannel: '自社チャネル',
        proxyChannel: 'プロキシチャネル',
        view: '表示',
        contactWay: '連絡先方法',
        open: '開く',
        close: '閉じる',
        operator: '操作人',
        selectStatus: '選択状態',
        generating: '生成中',
        generated: '生成済み',
        generateFailed: '生成失敗',
        generateStatus: '生成状態',
        fileName: 'ファイル名',
        fileInfo: 'ファイル情報',
        fileDownload: 'ファイルダウンロード',
        reGenerate: '再生成',
        downloadCount: 'ダウンロード回数',
        downloadRecord: 'ダウンロード記録',
        downloadTime: 'ダウンロード時間',
        operatorTime: '操作時間',
        roleNumber: 'ロール番号',
        roleName: 'ロール名',
        sort: 'ソート',
        operation: '操作',
        permission: '権限',
        createSubAccount: 'サブアカウントを作成',
        username: 'ユーザー名',
        account: 'アカウント',
        pleaseSelectRole: 'ロールを選択してください',
        accountStatus: 'アカウント状態',
        normal: '正常',
        disabled: '無効',
        role: 'アカウントロール',
        createTime: '作成時間',
        resetPassword: 'パスワードをリセット',
        sharedAccountData: '共有アカウントデータ',
        companyName: '会社名',
        distributionAccount: '配送アカウント',
        identifier: '識別子',
        level: 'レベル',
        logisticsChannel: '物流チャネル',
        accountBalance: 'アカウント残高',
        distributionDataStatistics: '配送データ統計',
        totalOrders: '総注文数',
        totalItems: '総商品数',
        totalCancelItems: '総キャンセル商品数',
        currentMonthCancelItems: '当月キャンセル商品数',
        totalRecharge: '総入金額',
        totalExpenditure: '総出金額',
        currentMonthOrders: '当月注文数',
        currentMonthItems: '当月商品数',
        totalPayOrders: '総支払注文数',
        totalPayItems: '総支払商品数',
        currentMonthPayOrders: '当月支払注文数',
        currentMonthPayItems: '当月支払商品数',
        viewLastMonthData: '前月データを表示',
        lastMonthOrders: '前月注文数',
        lastMonthItems: '前月商品数',
        lastMonthCancelItems: '前月キャンセル商品数',
        lastMonthPayOrders: '前月支払注文数',
        lastMonthPayItems: '前月支払商品数',
        lastMonthTotalRecharge: '前月総入金額',
        lastMonthTotalExpenditure: '前月総出金額',
        distributionAccounts: '配送アカウント',
        accountNickname: 'アカウントニックネーム',
        mainAccount: 'メインアカウント',
        remark: 'メモ',
        createdTime: '作成時間',
        pickUpInfo: '受取人情報',
        viewOrder: '注文を表示',
        logOff: 'ログアウト',
        pleaseUseEnglishOrPinyin: '送信者情報は英語またはピンインでご記入ください',
        senderName: '送信者名',
        senderState: '送信者省',
        senderCity: '送信者市',
        company: '会社名',
        email: 'メールアドレス',
        withdrawType: '出金種類',
        orderCommissionAmount: '注文コミッション額',
        shippingCommissionAmount: '出荷コミッション額',
        shippingReturnFee: '出荷返品料金',
        withdrawAmount: '出金額',
        yuan:'元',
        orderCommissionWithdrawableAmount: '注文コミッション可出金額',
        shippingCommissionWithdrawableAmount: '出荷コミッション可出金額',
        shippingReturnFeeWithdrawableAmount: '出荷返品料金可出金額',
        alipay: 'アリペイ',
        bankCard: 'バンクカード',
        wechat: 'Wechat',
        accountInfo: 'アカウント情報',
        oldPassword: '旧パスワード',
        newPassword: '新パスワード',
        confirmNewPassword: '新パスワードを確認',
        submit: '送信',
        recipient: '受取人',
        region: '地域',
        setDefault: 'デフォルトを設定',
        cancelDefault: 'デフォルトをキャンセル',
        deleteAddressConfirm: '住所を削除して続行しますか？',
        pleaseSelectPermission: '権限を選択してください！！！',
        deleteLabel: 'ラベルを削除して続行しますか？',
        password: 'パスワード',
        userName: 'ユーザー名',
        orderInfo: '注文情報',
        distributionCompanyName: '配送会社名',
        accountName: 'アカウント名',
        accountPassword: 'アカウントパスワード',
        phoneNumber: '電話番号',
        deliverWay: '配送方法',
        customerDescription: '顧客の説明',
        phoneNumberCannotBeEmpty: '電話番号を空にすることはできません',
        pleaseCorrectPhoneNumber: '電話番号を正しく入力してください',
        pleaseEnterCategoryName: 'カテゴリ名を入力してください',
        accountNameOrPinyin: 'アカウント名には中国語または中国語を含めることはできません',
        pleaseEnterAccountName: 'アカウント名を入力してください',
        pleaseEnterUserName: 'ユーザー名を入力してください',
        pleaseEnterPassword: 'パスワードを入力してください',
        pleaseSelectDeliverWay: '配送方法を選択してください',
        pleaseSelectOpenPick: '受取人を選択してください',
        productName: '製品名',
        productSku: '製品SKU',
        templateCategory: 'テンプレートカテゴリ',
        productInfo: '製品情報',
        adjustDistributionPrice: '配送価格を調整',
        craft: 'クラフト',
        pickUpPrice: '受取料金（￥）',
        distributionPrice: '配送価格（￥）',
        lowerLevelDistributionPrice: '下位流通価格(¥)',
        profit: '利益（￥）',
        shopName: 'ショップ名',
        platformShopOperator: 'プラットフォーム/ショップ/オペレーター',
        time: '時間',
        platformOrderTime: 'プラットフォーム注文時間',
        systemSyncTime: 'システム同期時間',
        latestDeliveryTime: '最新配送時間',
        processSize: '製造サイズ',
        orderProductInfo: '注文製品情報',
        quantity: '数量',
        price: '価格（￥）',
        status: '状態',
        pending: '待ち',
        designing: '設計中',
        designCompleted: '設計完了',
        productionCompleted: '製造完了',
        qualityInspection: '品質検査中',
        pendingDelivery: '待ち配送',
        delivered: '配送済み',
        cancelled: 'キャンセル済み',
        factory: '工場',
        orderNumber: '注文番号',
        delivery: '配送日',
        distributionInfo: '配信情報',
        totalStoreNums: '店舗数',
        totalPicSize: '画像空間',
        totalChildrenAccount: '子アカウント数',
        userQuota: 'ユーザークォータ',
        setSharedAccount: '共有アカウントを設定',
        functionTips1: '1.機能説明：他のアカウントにデータを共有する',
        functionTips2: '2.設定手順：',
        step1: '（1）共有アカウントを設定',
        step2: '（2）対応する共有権限を選択',
        sharedAccount: '共有アカウント',
        sharedPermission: '共有権限',
        selectAllPermission: 'すべての権限を選択',
        removeSharedAccount: '共有アカウントを削除',
        selectSharedAccount: '共有アカウントを選択',
    },

    v_header: {
        goHome: 'ホームに戻る',
        shoppingCart: 'ショッピングカート',
        processingCenter: '処理中心',
        productPendingGeneration: '製品待機生成',
        handle: 'ハンドル',
        notification: '通知',
        youAreWelcome: 'ようこそ！',
        balance: '残高',
        unit: 'Yuan',
        rebate: '返佣',
        freezeAmount: '{ frozen_money } (メタ) をフリーズして表示する',
        accountInfo: 'アカウント情報',
        transactionRecords: '取引記録',
        logOff: 'ログアウト',
    },

    shoppingCart: {
        shoppingCart: 'ショッピングカート',
        product: '製品',
        name: '名前',
        shippingCenter: '配送中心',
        pickUpSku: '受取SKU',
        productIdentifier: '製品識別子',
        compositeProductId: '組み合わせ製品ID',
        processSize: '製造サイズ',
        craft: '製造',
        size: 'サイズ',
        price: '価格(￥)',
        quantity: '数量',
        addTime: '追加時間',
        operation: '操作',
        delete: '選択した製品を削除',
        totalPrice: '総価格',
        checkout: '解決する',
        pleaseSelectItems: '操作に必要な項目を選択してください',
        confirmDelete: '本当に選択した製品を削除しますか？',
        checkoutPriceException: '決済データ価格が異常な場合は、管理者に連絡して処理してください',
        checkoutFactoryException: '異なる工場で生産を決済できない',
        pleaseSelectCheckoutItems: '结算に必要な製品を選択してください',
    },

    checkout_cart: {
        checkoutCart: 'チェックアウトカート',
        productInfo: '製品情報',
        name: '名前',
        shippingCenter: '配送中心',
        pickUpSku: '受取SKU',
        productIdentifier: '製品識別子',
        compositeProductId: '組み合わせ製品ID',
        processSize: '製造サイズ',
        price: '価格(￥)',
        unitPrice: '単価(￥)',
        quantity: '数量',
        subTotal: '小計',
        operation: '操作',
        orderBelong: '注文归属',
        platformOrderNumber: 'プラットフォーム注文番号',
        optional: 'オプション、入力した内容はプラットフォーム注文番号を生成する',
        shop: '店',
        shopTip: 'アカウントにショップがない場合、チェックアウト カートは自動的にセルフサービス ショップを作成します',
        deliveryMethod: '配送方法',
        shipments:'配送パッケージ',
        FBAShipping:'FBA 配送',
        pickUp:'受取',
        preOrder:'預かり注文',
        recipientInfo:'受取人情報',
        preOrderTip:'製品預かり注文が完了した後、ZFT 倉庫に一時的に格納され、後で注文生成と迅速な配送が可能になります',
        orderTotal:'注文合計',
        submit:'注文を提出',
        pleaseAddress:'配送先住所を選択してください',
        confirmSubmit:'チェックアウト カートの提出が成功し、注文が生成されましたか？',
        goToOrderView:'注文を表示',
        returnToShoppingCart:'ショッピングカートに戻る',
    },

    recharge: {
        recharge: '充電',
        accountInformation: 'アカウント情報',
        rechargeAccount: '充電アカウント',
        availableBalance: '利用可能残高',
        onlinePayment: 'オンライン支払い',
        bankTransfer: '銀行振込（オフライン振込）',
        rechargeAmount: '充電額',
        unit: 'Yuan',
        customAmount: 'カスタム金額',
        minimumRechargeAmount: '充電額は10元以上の整数である必要があります',
        paymentMethod: '支払方法',
        paymentAmount: '支払額',
        immediatePayment: '即時支払い',
        companyInfo: '会社情報',
        companyName: '会社名',
        bankName: '銀行名',
        bankAccount: '銀行口座',
        openingBank: '開設銀行',
        prompt: '温かいプロンプト: 資金がタイムリーに受け取られるように、送金後の送金のスクリーンショットを保管し、口座入力操作については営業スタッフに連絡してください。ご不明な点がございましたら、オンラインカスタマーサービスまたはビジネスマネージャーにお問い合わせください',
        pleaseInformation: '請先配置支払情報',
    },
}